import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "486",
  "slug": "why-greenland-looks-bigger-than-africa-on-maps",
  "title": "Why Greenland Looks So Large Beside Africa on a Mercator Map",
  "excerpt": "The comparison changes because Greenland lies much farther from the equator.",
  "date": "2026-06-19",
  "category": "Geography",
  "image": "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHx3b3JsZCUyMG1hcCUyMGdsb2JlfGVufDF8MHx8fDE3ODE4NTY3ODh8MA&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Greenland sits at high northern latitudes, while Africa spans the equator. Mercator scale increases toward the poles, so it enlarges Greenland much more than equatorial parts of Africa. Similar-looking areas on that map do not mean similar areas on Earth."
    },
    {
      "type": "heading",
      "text": "Check area without measuring the screen"
    },
    {
      "type": "paragraph",
      "text": "Use an equal-area world map to make a visual comparison. If you need a numerical ratio, divide area figures from a reference that states its units and scope. Do not count pixels in a Mercator screenshot: a pixel represents different ground areas at different latitudes."
    },
    {
      "type": "paragraph",
      "text": "On a globe, rotate each place toward the centre before comparing it. A country near the edge of a globe's screen image is foreshortened. Simply switching from a flat map to a screenshot of a globe does not make every visual measurement valid."
    },
    {
      "type": "heading",
      "text": "A useful classroom test"
    },
    {
      "type": "paragraph",
      "text": "Ask two people to estimate the relative areas from different maps, without telling them which projection they have. Then compare the maps and discuss which visual features affected their estimates. This is an exercise in reading a representation, not a test of which person knows more geography."
    }
  ],
  "sources": [
    {
      "title": "USGS: Map Projections",
      "url": "https://store.usgs.gov/assets/mod/storefiles/PDF/16573.pdf"
    }
  ],
  "relatedSlugs": [
    "mercator-projection-why-your-map-lies",
    "how-big-is-africa-really"
  ]
};
